import React, { useState, useEffect } from "react";
import useBirthdayMessage from "../../Hooks/useMessageList";
import { GoHeart, GoHeartFill } from "react-icons/go";
import { MdPublic } from "react-icons/md";
import { TbMessageFilled } from "react-icons/tb";
import {
  Wrapper,
  Container,
  GreetingList,
  GreetingItem,
  User,
  Profile,
  Name,
  Message,
  IconContainer,
  ButtonContainer,
  Button,
} from "./Greetings.styled";

const LOCAL_STORAGE_KEY = "greetingsClickedStates";

const formatDate = (dateString) => {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const formatter = new Intl.DateTimeFormat("en-US", options);
  return formatter.format(new Date(dateString));
};

const Greetings = () => {
  const { data, loading, error } = useBirthdayMessage();
  const [clickedStates, setClickedStates] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (data && data.birthdayMessages) {
      const storedStates =
        JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
      if (storedStates.length !== data.birthdayMessages.length) {
        setClickedStates(Array(data.birthdayMessages.length).fill(false));
      } else {
        setClickedStates(storedStates);
      }
    }
  }, [data]);

  useEffect(() => {
    if (clickedStates.length === data?.birthdayMessages?.length) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(clickedStates));
    }
  }, [clickedStates, data]);

  const handleClick = (index) => {
    setClickedStates((prevStates) => {
      const newClickedStates = [...prevStates];
      newClickedStates[index] = !newClickedStates[index];
      return newClickedStates;
    });
  };

  const handleShowMore = () => {
    setShowAll(true);
  };

  const handleShowLess = () => {
    setShowAll(false);
  };

  if (loading) return <p>Loading...</p>;
  if (error || !data) return <p>Error: {JSON.stringify(error)}</p>;

  const birthdayMessages = data.birthdayMessages;

  const sortedMessages = [...birthdayMessages].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const displayedMessages = showAll
    ? sortedMessages
    : sortedMessages.slice(0, 9);

  return (
    <Wrapper>
      <div className="heading">
        <TbMessageFilled />
        <h1>Greetings</h1>
      </div>
      <Container>
        <GreetingList>
          {displayedMessages.map((greeting, index) => (
            <GreetingItem key={greeting.id}>
              <User>
                <Profile
                  src={greeting.profile?.url || "/default-profile.png"}
                  alt={`Profile picture of ${greeting.name}`}
                />
                <Name>
                  <h4>{greeting.name}</h4>
                  <div className="date">
                    <p>{formatDate(greeting.createdAt)}</p>
                    <MdPublic />
                  </div>
                </Name>
              </User>
              <Message>
                <p
                  dangerouslySetInnerHTML={{ __html: greeting.message.html }}
                />
              </Message>
              <IconContainer onClick={() => handleClick(index)}>
                {clickedStates[index] ? (
                  <GoHeartFill className="icon" />
                ) : (
                  <GoHeart className="icon" />
                )}
              </IconContainer>
            </GreetingItem>
          ))}
        </GreetingList>
        <ButtonContainer>
          {!showAll && sortedMessages.length > 6 && (
            <Button onClick={handleShowMore}>Show More</Button>
          )}
          {showAll && <Button onClick={handleShowLess}>Show Less</Button>}
        </ButtonContainer>
      </Container>
    </Wrapper>
  );
};

export default Greetings;
